import './index.scss';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './app/App';

// Get our root container then render the App inside BrowserRouter.
const container = document.getElementById('root') as HTMLElement;
const app = (
  <BrowserRouter>
    {/* Change the payload url here if necessary */}
    <App id="app" payloadUrl="payload/vulnerabilities.json" />
  </BrowserRouter>
);
createRoot(container).render(app);
